import { Link } from "react-router-dom";
import { MessageCircle, Phone, SearchCheck } from "lucide-react";
import { useSite } from "@/context/SiteContext";

export function FloatingCTA() {
  const site = useSite();
  return (
    <>
      <a
        href={site.waLink}
        target="_blank"
        rel="noopener noreferrer"
        aria-label="Chat with Ravi Works on WhatsApp"
        data-testid="floating-whatsapp"
        className="hidden md:flex fixed bottom-6 right-6 z-40 h-14 w-14 items-center justify-center rounded-full bg-rw-green text-rw-bg glow-green transition-transform duration-200 hover:scale-110"
      >
        <MessageCircle size={26} />
      </a>

      <div className="md:hidden fixed bottom-0 inset-x-0 z-40 grid grid-cols-3 border-t border-rw-border bg-rw-bg2/95 backdrop-blur-xl" data-testid="mobile-sticky-cta">
        <Link to="/contact" data-testid="mobile-cta-audit"
          className="flex flex-col items-center gap-1 py-3 text-[11px] font-semibold text-rw-green">
          <SearchCheck size={20} /> SEO AUDIT
        </Link>
        <a href={site.waLink} target="_blank" rel="noopener noreferrer" data-testid="mobile-cta-whatsapp"
          className="flex flex-col items-center gap-1 py-3 text-[11px] font-semibold text-rw-text border-x border-rw-border">
          <MessageCircle size={20} className="text-rw-green" /> WHATSAPP
        </a>
        <a href={site.telLink} data-testid="mobile-cta-call"
          className="flex flex-col items-center gap-1 py-3 text-[11px] font-semibold text-rw-text">
          <Phone size={20} className="text-rw-blue" /> CALL
        </a>
      </div>
    </>
  );
}
